import { render } from "./AddFacilityForm.vue?vue&type=template&id=cb3a9bc4"
import script from "./AddFacilityForm.vue?vue&type=script&lang=js"
export * from "./AddFacilityForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__